const CATEGORIES = ['necessary', 'statistics'];
const CATEGORY_CONTENT = {
  necessary: {
    title: `Necessary`,
    message: `Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.`,
  },
  statistics: {
    title: `Statistics`,
    message: `Statistics cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.`,
  },
};
const CONSENT_COOKIE = 'cookieConsent';
const VERSION = '2020.02.25-v1';

export { CATEGORIES, CATEGORY_CONTENT, CONSENT_COOKIE, VERSION };
